import React from "react";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";

const CanonicalSelfReference = props => {
  const trailingSlashRegex = /\/$/;
  const getCanonicalPath = additionPath => {
    return !!additionPath
      ? `${props.location.pathname.replace(
          trailingSlashRegex,
          ""
        )}${additionPath}`
      : `${props.location.pathname.replace(trailingSlashRegex, "")}`;
  };
  return (
    <Helmet>
      <link rel="canonical" href={getCanonicalPath(props.appToPathname)} />
    </Helmet>
  );
};

export default withRouter(CanonicalSelfReference);
